<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState } from "vuex";

import { Auth } from "@/Helpers";
import { validate as uuidValidate } from "uuid";

export default {
  name: "App",
  data: function () {
    return {};
  },
  computed: {
    // ...mapState("Amedia", {
    //   AmediaCheck: (state) => state.check,
    // }),
  },
  methods: {
    // existToken: function () {
    //   let token = document.location.pathname.split("/").pop();
    //   if (uuidValidate(token)) {
    //     return token;
    //   }
    //   if (this.isJwt(token)) {
    //     return token;
    //   }
    //   return false;
    // },
    // checkSession: function () {
    //   return AuthST().check();
    // },
    // checkRouteLogin: function () {
    //   return this.$router.name == "login";
    // },
  },
  mounted: function () {
    if (Auth().getToken()) {
      this.$router.push({ name: "home" }).catch(() => {});
    } else {
      this.$router.push({ name: "logout" }).catch(() => {});
    }
  },
  // __mounted: function () {
  //   //- si hay session
  //   if (this.checkSession()) {
  //     //- si hay un token
  //     if (this.existToken() !== false) {
  //       if (AuthST().getToken() === this.existToken()) {
  //         //AuthST().console('Existe sesión y el token enviado es igual al storage...cargamos index.');
  //         this.$router.push({ name: "home" }).catch(() => {});
  //       } else {
  //         //AuthST().console('Existe sesión y el token enviado no es igual, cerramos sesión...hacemos nuevo login.');
  //         AuthST().logout();
  //         this.$router
  //           .push({ name: "login", params: { token: this.existToken() } })
  //           .catch(() => {});
  //       }
  //     }
  //     //- si no hay token
  //     else {
  //       //AuthST().console('No existe token en url ... hacemos un check en index...');
  //       this.$router.push({ name: "home" }).catch(() => {});
  //     }
  //   }
  //   //- si no hay session
  //   else {
  //     //- si existe un token
  //     if (this.existToken() !== false) {
  //       //AuthST().console('existe un token vamos a identificar...');
  //       this.$router.push({
  //         name: "login",
  //         params: { token: this.existToken() },
  //       });
  //     }
  //     //- si no existe un token
  //     else {
  //       //AuthST().console('página logout...');
  //       this.$router.push({ name: "logout" }).catch(() => {});
  //     }
  //   }
  // },
};
</script>
